import React from 'react';
import './Pagination.css';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  if (!totalPages || totalPages <= 1) return null;

  const maxVisiblePages = 9; // Максимальное количество видимых страниц (без учета "...")
  let pages = [];

  if (totalPages <= maxVisiblePages) {
    // Если общее количество страниц меньше или равно максимальному, отображаем все страницы
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    // Если текущая страница ближе к началу
    if (currentPage <= 5) {
      for (let i = 1; i <= 9; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    }
    // Если текущая страница ближе к концу
    else if (currentPage > totalPages - 5) {
      pages.push(1);
      pages.push('...');
      for (let i = totalPages - 8; i <= totalPages; i++) {
        pages.push(i);
      }
    }
    // Если текущая страница в середине
    else {
      pages.push(1);
      pages.push('...');
      for (let i = currentPage - 3; i <= currentPage + 3; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    }
  }

  return (
    <div className="pagination">
      {pages.map((page, index) =>
        page === '...' ? (
          <span key={`ellipsis-${index}`} className="pagination__ellipsis">
            ...
          </span>
        ) : (
          <button
            key={`page-${page}`}
            className={`pagination__button ${currentPage === page ? 'pagination__button--active' : ''}`}
            onClick={() => onPageChange(page as number)}
          >
            {page}
          </button>
        ),
      )}
      {currentPage < totalPages && (
        <button className="pagination__next" onClick={() => onPageChange(currentPage + 1)}>
          Дальше
        </button>
      )}
    </div>
  );
};

export default Pagination;
